import CallToAction from './call-to-action';

export default CallToAction;
